// All landing-page content lives here so JSX stays clean.

export const company = {
    name: "Atvicon Technologies",
    tagline: "Engineering the Future of Indian Software.",
    phone: "+91 63940 58460",
    email: "mohd.aquib@atvicon.com",
    address: "Colonel Ganj, Prayagraj, Uttar Pradesh — India",
    whatsapp: "https://wa.me/916394058460",
};

export const navLinks = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Products", href: "#products" },
    { label: "Why Us", href: "#why-us" },
    { label: "Contact", href: "#contact" },
];

export const services = [
    {
        id: "marketing-automation",
        icon: "Zap",
        title: "Marketing Automation",
        tagline: "Pipelines that sell while you sleep.",
        description:
            "End-to-end automation for WhatsApp, Email and SMS — built on top of CRMs to turn cold visitors into paying customers without a marketing team.",
        bullets: [
            "WhatsApp Business API drip campaigns",
            "Lead capture → CRM → nurture workflows",
            "Behaviour-based email sequences (Resend / SES)",
            "Conversion analytics & A/B testing dashboards",
        ],
        accent: "from-cyan-400/40 to-blue-500/0",
    },
    {
        id: "full-stack",
        icon: "Layers",
        title: "Full Stack Development",
        tagline: "Production-grade web platforms.",
        description:
            "React, Next.js, FastAPI, Node and MongoDB / Postgres — engineered for scale on AWS, GCP or self-hosted Kubernetes clusters.",
        bullets: [
            "SaaS platforms with auth, billing, dashboards",
            "Realtime apps with WebSockets & queues",
            "API design, microservices & data pipelines",
            "Performance audits, SEO & Core Web Vitals",
        ],
        accent: "from-violet-400/40 to-cyan-500/0",
    },
    {
        id: "app-dev",
        icon: "Smartphone",
        title: "Mobile App Development",
        tagline: "iOS & Android, beautifully native.",
        description:
            "Flutter and React Native apps with offline-first sync, push notifications and crash-free reliability above 99.5%.",
        bullets: [
            "Cross-platform apps with native modules",
            "Offline-first architecture & sync engines",
            "Razorpay / Stripe payment integration",
            "Play Store & App Store launch support",
        ],
        accent: "from-blue-400/40 to-violet-500/0",
    },
    {
        id: "ai-custom",
        icon: "BrainCircuit",
        title: "AI & Custom Software",
        tagline: "LLMs that actually ship.",
        description:
            "Custom AI assistants, RAG systems, document automation and computer-vision pipelines tailored to your domain.",
        bullets: [
            "GPT, Claude & Gemini integrations",
            "RAG over private docs (legal, medical, edu)",
            "AI voice agents & WhatsApp copilots",
            "Fine-tuned models on your proprietary data",
        ],
        accent: "from-cyan-400/40 to-violet-500/0",
    },
];

export const products = [
    {
        id: "rapid-steno",
        name: "Rapid Steno",
        url: "https://rapidsteno.com/",
        tag: "EdTech · Govt Exams",
        headline:
            "India’s #1 stenography & shorthand training software for SSC and High Court aspirants.",
        long: "An all-in-one Govt-exam preparation platform offering advanced shorthand dictations, AHC formatting templates, Pitman practice and AI-powered mistake analysis. Includes Essay, Letter, Translation and Live Mock Tests for RO/ARO, PS/APS, SSC CGL, CHSL and 30+ exams.",
        features: [
            { icon: "Mic", label: "Court & KC Dictations" },
            { icon: "Brain", label: "AI Mistake Analysis" },
            { icon: "FileText", label: "100+ Formatting Templates" },
            { icon: "Gauge", label: "Speed Booster (60→120 WPM)" },
            { icon: "BookOpen", label: "Pitman Book Revision" },
            { icon: "Trophy", label: "Live Mock Tests & Leaderboard" },
        ],
        stats: [
            { v: "5,000+", l: "Students" },
            { v: "30+", l: "Exam Batches" },
            { v: "23+", l: "States" },
        ],
        cta: "Visit Rapid Steno",
        image: "https://ik.imagekit.io/rapidsteno/ChatGPT%20Image%20Jun%2024,%202026,%2009_08_57%20AM.png",
        glow: "rgba(0,229,255,0.35)",
    },
    {
        id: "typing-orbit",
        name: "Typing Orbit",
        url: "https://typingorbit.com/",
        tag: "EdTech · Typing Platform",
        headline:
            "Master typing. Orbit your success — built for 35+ Indian Govt typing exams.",
        long: "India’s most advanced typing platform with real exam patterns, live WPM/accuracy tracking, custom matter uploads, 17+ court-approved fonts and detailed weekly analytics that actually improve your speed.",
        features: [
            { icon: "Activity", label: "Real-time WPM & Accuracy" },
            { icon: "BarChart3", label: "Detailed Performance Analytics" },
            { icon: "Type", label: "17+ Court-Approved Fonts" },
            { icon: "Upload", label: "Custom Typing Matter Upload" },
            { icon: "Crown", label: "Leaderboard & Rankings" },
            { icon: "Laptop", label: "Mobile · Tablet · Desktop" },
        ],
        stats: [
            { v: "35+", l: "Govt Exams" },
            { v: "10K+", l: "Typing Tests" },
            { v: "99.5%", l: "Uptime" },
        ],
        cta: "Visit Typing Orbit",
        image: "https://ik.imagekit.io/rapidsteno/ChatGPT%20Image%20Jun%2024,%202026,%2009_10_51%20AM.png",
        glow: "rgba(124,92,255,0.35)",
    },
    {
        id: "lawgrafter",
        name: "LawGrafter",
        url: "https://lawgrafter.com/",
        tag: "LegalTech · AI",
        headline:
            "AI-powered legal drafting for High Court advocates — annexures, summaries and citations in seconds.",
        long: "Built for Indian High Court chambers. Generate professional annexure tables, English & Hindi case summaries, find ruling precedents and export to DOCX with court-grade legal margins. Save 2-3 hours per matter.",
        features: [
            { icon: "Sparkles", label: "AI Annexure Table Generator" },
            { icon: "Languages", label: "English & Hindi Summaries" },
            { icon: "Search", label: "Ruling Cases Finder" },
            { icon: "FileDown", label: "DOCX Export · Legal Margins" },
            { icon: "ShieldCheck", label: "Bank-grade Confidentiality" },
            { icon: "Scale", label: "High Court Style Formatting" },
        ],
        stats: [
            { v: "7 Days", l: "Free Trial" },
            { v: "₹2", l: "Per Credit" },
            { v: "100%", l: "DOCX Ready" },
        ],
        cta: "Visit LawGrafter",
        image: "https://ik.imagekit.io/rapidsteno/ChatGPT%20Image%20Jun%2024,%202026,%2009_13_10%20AM.png",
        glow: "rgba(0,85,255,0.35)",
    },
    {
        id: "ai-exam-hub",
        name: "AI Exam Hub",
        url: "https://rapidsteno.com/",
        tag: "EdTech · AI · RO/ARO · PS/APS",
        headline:
            "The complete AI-powered preparation suite for RO/ARO and PS/APS aspirants.",
        long: "Six exam-grade modules — Mock Tests, AI Translation, AI Essay, Comprehension, AI Précis and a dedicated AHC Typing Software — built around the latest High Court exam pattern. Every module gives instant, examiner-style AI feedback so you know exactly where to improve.",
        features: [
            { icon: "ClipboardCheck", label: "Mock Test Section · Timed" },
            { icon: "Languages", label: "Hindi ↔ English AI Translation" },
            { icon: "PenLine", label: "AI Essay Writing · 18 Topics" },
            { icon: "Keyboard", label: "AHC Typing Software" },
            { icon: "BookOpenCheck", label: "Comprehension · 40 Passages" },
            { icon: "FileText", label: "AI Précis Writing · 24 Topics" },
        ],
        stats: [
            { v: "6", l: "Modules" },
            { v: "AI", l: "Powered" },
            { v: "RO/ARO", l: "PS/APS" },
        ],
        cta: "Explore AI Exam Hub",
        image: "https://ik.imagekit.io/rapidsteno/ChatGPT%20Image%20Jun%2024,%202026,%2009_17_55%20AM.png",
        glow: "rgba(255,44,212,0.32)",
    },
];

export const whyChooseUs = [
    {
        icon: "Flag",
        title: "Built for Bharat",
        desc: "Every product is engineered ground-up for Indian users — Hindi support, Indian exam patterns, INR pricing and local payment rails.",
    },
    {
        icon: "Sparkles",
        title: "AI-First Engineering",
        desc: "Our products ship with real AI — not stickers. From mistake analysis to legal precedent search, LLMs are core to every workflow.",
    },
    {
        icon: "Rocket",
        title: "Ship in Weeks, Not Quarters",
        desc: "A senior-only team, modern stack and battle-tested templates let us deliver production MVPs in 4–8 weeks.",
    },
    {
        icon: "ShieldCheck",
        title: "Enterprise-Grade Security",
        desc: "Bank-level encryption, role-based access, audit logs and full compliance with Indian data-protection norms.",
    },
    {
        icon: "Headphones",
        title: "Founder-Led Support",
        desc: "Talk to the people who built your product. Mon-Sat support across WhatsApp, email and phone — no offshore call-centres.",
    },
    {
        icon: "TrendingUp",
        title: "Proven Outcomes",
        desc: "5,000+ exam aspirants, 23+ states served, ₹0 advertising spent — only word-of-mouth growth from happy customers.",
    },
];

export const stats = [
    { value: 50000, suffix: "+", label: "Active Users" },
    { value: 35, suffix: "+", label: "Govt Exams Covered" },
    { value: 23, suffix: "+", label: "States Reached" },
    { value: 4, suffix: "", label: "Flagship Products" },
    { value: 10, suffix: "K+", label: "Tests Taken" },
    { value: 95, suffix: "%", label: "Success Rate" },
];

export const testimonials = [
    {
        name: "Pradeep Sharma",
        role: "AHC Dictation · Rapid Steno",
        city: "New Delhi",
        avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=200&q=80",
        quote: "Game changer for AHC prep! The dictation practice was spot-on and the analysis tools helped me track my errors. I went from struggling to clearing the exam.",
        rating: 5,
    },
    {
        name: "Anjali Verma",
        role: "SSC Steno · Rapid Steno",
        city: "Lucknow",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
        quote: "My speed jumped from 60 to 100 WPM! The variety of dictations and practice materials is outstanding. Rapid Steno made my SSC prep structured and effective.",
        rating: 5,
    },
    {
        name: "Rohit Verma",
        role: "SSC CGL Aspirant · Typing Orbit",
        city: "Patna",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
        quote: "My typing speed improved from 32 WPM to 55 WPM in just 20 days. The analytics really helped me a lot! Best platform for govt exam typing practice.",
        rating: 5,
    },
    {
        name: "Kavita Singh",
        role: "AHC Pass · Rapid Steno",
        city: "Prayagraj",
        avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80",
        quote: "AHC formatting typing section ke liye main bahut nervous thi. 35+ formatting tests ne mujhe exam jaisa experience diya. 6 hafte mein 45 se 65 WPM ho gayi.",
        rating: 5,
    },
    {
        name: "Neha Singh",
        role: "RRB NTPC Aspirant · Typing Orbit",
        city: "Lucknow",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80",
        quote: "Best typing platform for exam preparation. The real-time feedback and practice tests are amazing. Custom matter upload feature is a lifesaver.",
        rating: 5,
    },
    {
        name: "Vikram Singh",
        role: "Gold Pass · Rapid Steno",
        city: "Allahabad",
        avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
        quote: "Worth every single penny! The exam-style practice and progress tracking features are exactly what I needed. The mock tests feel just like the real exam.",
        rating: 5,
    },
    {
        name: "Priya Sharma",
        role: "Bank PO Aspirant · Typing Orbit",
        city: "Jaipur",
        avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
        quote: "Typing Orbit is a game-changer! My accuracy is now above 95%. Highly recommended for all aspirants preparing for government exams.",
        rating: 5,
    },
    {
        name: "Shabeena Khan",
        role: "AHC Special Matter · Rapid Steno",
        city: "Srinagar",
        avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=200&q=80",
        quote: "Achieved 96.98% accuracy on AHC Special Matter using Rapid Steno. Real-time feedback and precision tools lead to outstanding results.",
        rating: 5,
    },
    {
        name: "Aman Yadav",
        role: "UPSC Aspirant · Typing Orbit",
        city: "Varanasi",
        avatar: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=200&q=80",
        quote: "I love the custom typing tests and progress tracking. It keeps me motivated to improve every day. The 17+ fonts option is perfect for court-style practice.",
        rating: 5,
    },
    {
        name: "Sunita Devi",
        role: "KC Magazine Batch · Rapid Steno",
        city: "Meerut",
        avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=200&q=80",
        quote: "KC dictations se accuracy kaafi badhi! Dictation ke baad jo word-level mistake report milti hai wo bahut detailed hoti hai. Coaching se zyada effective.",
        rating: 5,
    },
];

export const faqs = [
    {
        q: "What does Atvicon Technologies actually do?",
        a: "We are a Prayagraj-based product & services company. We build and operate our own SaaS products (Rapid Steno, Typing Orbit, LawGrafter) and also work with businesses on marketing automation, full-stack web platforms, mobile apps and custom AI solutions.",
    },
    {
        q: "Which industries do you typically work with?",
        a: "EdTech, LegalTech, D2C, logistics, healthcare and financial services. If your problem can be solved with software + AI, we are usually a strong fit.",
    },
    {
        q: "How long does a typical project take?",
        a: "Most MVPs ship in 4–8 weeks. Larger platforms (full SaaS with billing, dashboards and AI) run 10–16 weeks. We share a phase-wise plan after the first discovery call.",
    },
    {
        q: "Do you offer post-launch maintenance?",
        a: "Yes — every project includes 30 days of free post-launch support. After that you can opt for a monthly retainer covering bug-fixes, infrastructure monitoring and small feature requests.",
    },
    {
        q: "Can I just subscribe to your products without hiring you?",
        a: "Absolutely. Rapid Steno, Typing Orbit and LawGrafter are fully self-serve. Visit the respective product website to start a free trial — no calls required.",
    },
    {
        q: "Do you sign NDAs?",
        a: "Yes, we sign mutual NDAs before sharing any project details or product roadmaps. Your idea is safe with us.",
    },
    {
        q: "What technologies do you specialise in?",
        a: "React, Next.js, FastAPI, Node.js, MongoDB, Postgres, Flutter, React Native, OpenAI, Anthropic Claude, Google Gemini, AWS and GCP.",
    },
    {
        q: "Where are you located and do you work with international clients?",
        a: "Our HQ is in Colonel Ganj, Prayagraj (Uttar Pradesh, India). We work remotely with clients across India, the UAE, the UK and North America.",
    },
];
